/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { CollectionResponse, PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface VocabularySearchParams extends PageQueryParams {
  search?: string
  reference_type?: string
  user_id?: number
  type?: string
}

export interface VocabularyApiParams {
  page: number
  limit: number
  search?: string
  reference_type?: string
  user_id?: number
  type?: string
  set_id?: number
}

export const vocabularyService = {
  list(params: VocabularyApiParams) {
    return HttpRequest.get("v1/vocabularies", {
      searchParams: params as any,
    }).json<CollectionResponse>()
  },
  bulkAdd(data: { set_id: number; vocabularies: any[] }) {
    return HttpRequest.post("v1/vocabularies/bulk", {
      json: data,
      timeout: false,
    }).json<{
      code: number
      message: string
    }>()
  },
  update(id: number, data: Partial<any>) {
    return HttpRequest.put(`v1/vocabularies/${id}`, {
      json: data,
    }).json<{
      code: number
      message: string
      data?: any
    }>()
  },
}
